module.exports = __webpack_public_path__ + "img/23.02a06928.jpg";